const INVESTOR_CONCENTRATION_RATE_FIELDS = [
  'professional_investor_concentration_rate',
  'retail_investor_concentration_rate'
];

export const SECTION_ERROR_SCOPE = {
  INVESTOR_CONCENTRATION2: {
    tableKey: 'INVESTOR_CONCENTRATION',
    mode: 'include',
    fields: INVESTOR_CONCENTRATION_RATE_FIELDS
  },
  INVESTOR_CONCENTRATION: {
    tableKey: 'INVESTOR_CONCENTRATION',
    mode: 'exclude',
    fields: INVESTOR_CONCENTRATION_RATE_FIELDS
  }
};
